import { atom } from 'jotai';

import type { ReviewAnswerWithQuestionnaireResponse } from '@/types/review/ReviewAnswer';

export const reviewAnswerAtom = atom<ReviewAnswerWithQuestionnaireResponse | undefined>(undefined);
